import React from 'react';

import * as ROUTES from 'constants/routes';

const MenuLeft = ({lang, user, currentPage}) => {	
	return (
		<div id="sidebar" className="sidebar responsive ace-save-state">
      <div className="sidebar-shortcuts" id="sidebar-shortcuts">
				<ul className="nav nav-list">
					<li className={currentPage === 'landing' ? 'active' : ''}>
						<a href={ROUTES.LANDING}>
							<i className="menu-icon fa fa-home"></i>
							<span className="menu-text"> Главная </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className={currentPage === 'categories' ? 'active' : ''}>
						<a href={ROUTES.CATEGORIES}>
							<i className="menu-icon fa fa-file"></i>
							<span className="menu-text"> Категории </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className={currentPage === 'subcategories' ? 'active' : ''}>
						<a href={ROUTES.SUBCATEGORIES}>
							<i className="menu-icon fa fa-file-o"></i>
							<span className="menu-text"> Подкатегории </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className={currentPage === 'questions' ? 'active' : ''}>
						<a href={ROUTES.QUESTIONS}>
							<i className="menu-icon fa fa-question"></i>
							<span className="menu-text"> Вопросы </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className={currentPage === 'users' ? 'active' : ''}>
						<a href={ROUTES.USERS}>
							<i className="menu-icon fa fa-users"></i>
							<span className="menu-text"> Пользователи </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className={currentPage === 'rating' ? 'active' : ''}>
						<a href={ROUTES.RATING}>
							<i className="menu-icon fa fa-signal"></i>
							<span className="menu-text"> Рейтинг </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className="">
						<a href="index.html">
							<i className="menu-icon fa fa-leaf"></i>
							<span className="menu-text"> Ответы </span>
						</a>

						<b className="arrow"></b>
					</li>

					<li className={currentPage === 'notification' ? 'active' : ''}>
						<a href={ROUTES.NOTIFICATION}>
							<i className="menu-icon fa fa-comments"></i>
							<span className="menu-text"> Push-сообщения </span>
						</a>

						<b className="arrow"></b>
					</li>
				</ul>

				<div className="sidebar-toggle sidebar-collapse" id="sidebar-collapse">
					<i id="sidebar-toggle-icon" className="ace-icon fa fa-angle-double-left ace-save-state" data-icon1="ace-icon fa fa-angle-double-left" data-icon2="ace-icon fa fa-angle-double-right"></i>
				</div>
			</div>
    </div>
  );
};
    
export default MenuLeft;

/*
<ul>
          <li>
            <Link to={ROUTES.LANDING}>Landing</Link>
          </li>
          <li>
            <Link to={ROUTES.SIGN_IN}>Login</Link>
          </li>
          {userAuth.isAuthenticated ? (
            <li>
            <Link to={ROUTES.CATEGORIES}>Categories</Link>
          </li>
          ) : null}  
        </ul>
*/